import React, { useState, useEffect } from 'react';
import './ConnectivityHandler.css';

const ConnectivityHandler = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [wasOffline, setWasOffline] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setWasOffline(true);
      setTimeout(() => setWasOffline(false), 3000);
    };
    
    const handleOffline = () => {
      setIsOnline(false);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return (
    <>
      {!isOnline && (
        <div className="connectivity-banner offline">
          ⚠️ You are offline. Uploads will queue until connection is restored.
        </div>
      )}
      
      {wasOffline && isOnline && (
        <div className="connectivity-banner online">
          ✅ Connection restored. Resuming uploads...
        </div>
      )}
    </>
  );
};

export default ConnectivityHandler;
